module.exports = __webpack_public_path__ + "../static/img/other-fail.db12c84d.png";